import React, { useEffect, useState } from "react";
import Analytics from "../common/Analytics";
import axios from "axios";
import { Box, Button, Typography } from "@mui/material";
import DateRangeSearch from "../common/DateRangeSearch";
import useNotification from "../common/Notification";
import dayjs from "dayjs";
// import { Cookie } from "@mui/icons-material";
import Cookies from "js-cookie";
import axiosInstance from "../../api/axiosInstance";

import EmailDownloadReport from "../common/EmailDownloadReport";
import { blue } from "@mui/material/colors";

const dummy_data = [
    { Pending: 125 },
    { Completed: 80 },
    { Failed: 20 },
    { Total: 225 },
];
const EmailAnalytics = () => {
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState(dayjs());

    const [endDate, setEndDate] = useState(dayjs());
    const [reportData, setReportData] = useState({});

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];
    

    console.log(formattedStartDate, formattedEndDate);

    const notify = useNotification();

    const fetchEmailStatus = async () => {
        if (!startDate || !endDate) {
            notify("Please Select start and end date!", "error");
            return;
        }
        const userId = Cookies.get("userId");

        try {
            const res = await axiosInstance.get(
                `https://api.virtualprachar.com/api/emails/email-report?date1=${startDate.format(
                    "YYYY-MM-DD"
                )}&date2=${endDate.format("YYYY-MM-DD")}`
            );
            const newData = [
                { Completed: res.data.total_complete_count },
                { Pending: res.data.total_pending_count },
                { Failed: res.data.total_failed_count },
                { Read: res.data.total_read_count },
                { Total: res.data.total_email },

            ];
            setReportData(res.data);
            console.log(res.data);
            setData(newData);
        } catch (e) {
            console.error("Error: ", e);
        } finally {
            //
        }
    };
    useEffect(() => {
        fetchEmailStatus();
    }, []);
    return (
        <Box
            sx={{
                width: "100%",
                // height: "80vh",

                display: "flex",
                paddingTop: "1rem",

                flexDirection: "column",
                // marginTop: 3,
                // justifyContent: "center",
                // alignItems: "center",
            }}
        >
      <Typography variant='h6'  sx={{ mb: 4, mt: 3, color : 'primary.main', backgroundColor:blue[50], px:2, width: 'fit-content', py:1, borderRadius:2, fontWeight:'bold'}}>
        Email Analytics Overview
      </Typography>
            {/* <Box sx={{width:'100%'
        }}>
            
        </Box> */}

            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    height: "auto",
                }}
            >
                <DateRangeSearch
                    startDate={startDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                    handleSearch={fetchEmailStatus}
                />

                <EmailDownloadReport
                    data={reportData}
                    startDate={formattedStartDate}
                    endDate={formattedEndDate}
                />
            </Box>

            <Analytics data={data} name={"Email"} />
        </Box>
    );
};

export default EmailAnalytics;
